@if (supportTickets?.length) {
  <div class="support-tickets-container">
    @for (ticketData of supportTickets; track ticketData) {
      <div class="ticket-card">
        <div class="ticket-title-row">
          <span class="ticket-status-pill" [ngClass]="getStatusClass(ticketData.status)">
            {{ (ticketData?.status || 'open') | titlecase }}
          </span>
          <span class="ticket-title">
            [#{{ ticketData?.id }}] {{ ticketData?.subject }}
          </span>
        </div>
        <div class="ticket-meta-row">
          <span>Assignee: <em>{{ ticketData?.assignee || '-' }}</em></span>
          <span>|</span>
          <span>Requested on: <em>{{ ticketData?.requestedOn || '-' }}</em></span>
          <span>|</span>
          <span>Last Updated: <em>{{ ticketData?.lastUpdated || '-' }}</em></span>
          @if (ticketData?.siteName) {
            <span>|</span>
          }
          @if (ticketData?.siteName) {
            <span>Site Name: <em>{{ ticketData?.siteName }}</em></span>
          }
        </div>
      </div>
    }
  </div>
}
